<template>
  <div>
    <div id="footer">
      <div class="container">
        <div class="col-xs-12 col-sm-hidden col-md-4">
          <br>
          <div class="logo_title">
            <img src="@/assets/img/logo_fotter.png" alt="logo图" style="height: 100px;width: auto; margin-bottom: 10%">

            <!--            <img src="@/assets/img/code1.png" alt="logo图" style="height: 120px;width: auto; margin-bottom: 10%">-->
            <div>
              <p style="color: #cbcbcb">公司地址</p>
              <p style="font-size: 20px">上海市宝山区富联三路99号三幢</p>
            </div>
            <div style="margin-top: 10%">
              <p style="color: #cbcbcb">电话</p>
              <p style="font-size: 20px">021-51853815</p>
              <p style="font-size: 20px">400-0021-908</p>
            </div>
            <div style="margin-top: 10%">
              <p style="color: #cbcbcb">邮箱</p>
              <p style="font-size: 20px">infor@sinochrome.cn</p>
            </div>
            <div style="margin-top: 30%; color: #cbcbcb">
              <p>版权所有&copy; 2018 - {{ new Date().getFullYear() }} 上海乐辰生物科技有限公司 </p>
              <a style="white-space: nowrap; color: #cbcbcb" href="https://beian.miit.gov.cn">沪ICP备11005475号</a>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-hidden col-md-8" id="products" style="margin-top: 5%">
          <div class="col-xs-12 col-sm-hidden col-md-3">
            <div class="navigation-name">仪器</div>
            <div v-for="item in products.instrument" class="product-name">
              <router-link style="color:#ffffff;" :to="'/product/instrumentPage/'+item.id">{{ item.name }}</router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-hidden col-md-3">
            <div class="navigation-name">试剂</div>
            <div v-for="item in products.reagent" class="product-name">
              <router-link style="color:#ffffff;" :to="'/product/reagentPage/'+item.id"> {{ item.name }}</router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-hidden col-md-3">
            <div class="navigation-name">软件</div>
            <div v-for="item in products.software" class="product-name">
              <router-link style="color:#ffffff;" :to="'/product/softwarePage/'+item.id">{{ item.name }}</router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-hidden col-md-3">
            <div class="navigation-name">关于我们</div>
            <div class="product-name">
              <router-link style="color:#ffffff;" :to="'/contactus'">联系我们</router-link>
            </div>
            <div class="product-name">
              <router-link style="color:#ffffff;" :to="'/recruitment'">人才招聘</router-link>
            </div>
            <div class="product-name">
              <router-link style="color:#ffffff;" :to="'/aboutUs'">关于我们</router-link>
            </div>
          </div>
          <!--          <button class="btn btn-default btn-sm">
                      <router-link :to="'contactus'">联系我们</router-link>
                    </button>-->
          <div style="margin-top: 350px; margin-left: 520px; display: flex">

            <img src="@/assets/img/code1.png" alt="logo图" style="height: 120px;width: auto; margin-right: 20px">
            <img src="@/assets/img/code.jpg" alt="logo图" style="height: 120px;width: auto; ">
          </div>
        </div>


        <div class="col-xs-12 col-sm-hidden col-md-12" id="products" style="margin-top: 5%">

        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {getAction} from "../api/manage";

export default {
  name: "Footer",
  data() {
    return {
      products: {
        instrument: [],
        reagent: [],
        software: []
      }
    };
  },
  created() {
    this.loadInstrumentNav();
    this.loadSoftwareNav();
    this.loadReagentNav();
    console.log(this.products)
  },
  methods: {

    // 加载仪器导航
    loadInstrumentNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          isNav: '1',
          name: '',
          remark: ''
        }
      }
      getAction('/instrument/list', queryParam).then((res) => {
        this.products.instrument = res.data.data.rows;
      })

    },
    // 加载试剂导航
    loadSoftwareNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          id: '',
        }
      }
      getAction('/reagent/list', queryParam).then((res) => {
        this.products.reagent = res.data.data.rows;
      })

    },
    // 加载软件导航
    loadReagentNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          isNav: '1',
        }
      }
      getAction('/software/list', queryParam).then((res) => {
        this.products.software = res.data.data.rows;
      })
    },

  }
};
</script>
<style scoped>
#footer {
  font-size: 15px;
  width: 100%;
  height: 600px;
  color: #ffffff;
  background-color: #448ef7;
  /*  background: #ad997a;*/
  overflow: hidden;
}

.logo {
  margin-top: 20px;
  width: 400px;
}

.logo img {
  float: right;
}

.logo_title {
  margin-top: 20px;
  width: 400px;
  line-height: 16px;
}

#footer table {
  margin-top: 30px;
  width: 510px;
}

#footer table th {
  width: 170px;
  font-size: 28px;
  padding-bottom: 30px;
}

#footer table td {
  font-size: 18px;
  padding: 5px;

}

.copy {
  color: #000000;
  font-size: 14px;
  margin: auto;
  text-align: center;
}

.navigation-name {
  font-size: 19px;
  margin-bottom: 50px;
}

.product-name {
  margin-top: 20px;
  font-size: 14px
}

@media screen and (max-width: 997px) {
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }

  .logo_title {
    padding-left: 0;
    margin-top: 0;
    width: 100%;
    line-height: 16px;
  }

  #products {
    display: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue